export default __webpack_public_path__ + "static/media/premium_plus_card.4da890dc.png";